import {Item} from './Item'
import {LocalExperts} from './widgets/LocalExperts'
import {TopRated} from './widgets/TopRated'
import {TrustBlockTitle} from './widgets/TrustBlockTitle'
import {WorryFree} from './widgets/WorryFree'

export const TrustBlock = () => {
  return (
    <div className="rounded-lg flex flex-col gap-4">
      <div className="font-bold text-[18px]">Book with confidence</div>
      <Item
        title={<TrustBlockTitle prefix="localExpertsTitle" defaultTitle="Local experts" />}
        description={<LocalExperts />}
      />
      <Item
        title={<TrustBlockTitle prefix="topRatedTitle" defaultTitle="Top-rated" />}
        description={<TopRated />}
      />
      <Item
        title={<TrustBlockTitle prefix="worryFreeTitle" defaultTitle="Worry-free booking" />}
        description={<WorryFree />}
      />
    </div>
  )
}
